import { Icon, IconButton, Modal } from "@material-ui/core";
import React, { ReactNode, useCallback, useEffect, useState } from "react";
import styles from "./BottomModal.module.scss";
import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";

interface BottomModalProps {
  title?: string;
  image?: any;
  message?: string;
  confirmTitle?: string;
  onClickConfirm?: () => void;
  onClickClose?: () => void;
  hideCloseButton?: boolean;
  closeButtonTile?: string;
  children?: ReactNode;
  showModal?: boolean;
}

const BottomModal: React.FC<BottomModalProps> = ({
  confirmTitle,
  image,
  message,
  onClickConfirm,
  onClickClose,
  title,
  hideCloseButton,
  closeButtonTile,
  children,
  showModal,
}) => {
  const { resolution } = useScreenStore();

  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);

  const confirm = useCallback(() => {
    onClickConfirm && onClickConfirm();
    setVisible(false);
  }, [onClickConfirm]);

  const close = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e?.preventDefault?.();
      onClickClose && onClickClose();
    },
    [onClickClose],
  )
  

  useEffect(() => {
    if (showModal) {
      setVisible(true);
      setTimeout(() => setAnimate(true), 50);
    } else {
      setAnimate(false);
      setTimeout(() => {
        setVisible(false);
      }, 300);
    }
  }, [showModal]);

  return (
    <Modal
      open={visible}
      onClick={(e) => e.stopPropagation()}
      onClose={!hideCloseButton ? close : () => {}}
      BackdropProps={{
        style: {
          backdropFilter: "none",
        },
      }}
    >
      <div
        className={styles.actionModalContainer}
        style={{
          transform: animate ? "translate(-50%, 0)" : "translate(-50%, 100%)",
          transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
          opacity: animate ? 1 : 0,
        }}
      >
        {!hideCloseButton && (
          <div className={styles.close}>
            <IconButton onClick={(e) => close(e)}>
              <Icon>close</Icon>
            </IconButton>
          </div>
        )}
        <div className={styles.content}>
          {title && <div className={styles.title}>{title}</div>}
          {image && (
            <div className={styles.imageContainer}>
              <img className="image" src={image} alt="Imagem" />
            </div>
          )}
          <div className={styles.text}>{message}</div>
          <div className={styles.children}>{children}</div>
          <div className={styles.buttonsContainer}>
            {confirmTitle && (
              <button
                style={{
                  height: resolution === ResolutionType.FULL_HD ? 120 : 90,
                }}
                onClick={confirm}
              >
                {confirmTitle}
              </button>
            )}
            {closeButtonTile && (
              <button
                style={{
                  height: resolution === ResolutionType.FULL_HD ? 120 : 90,
                }}
                onClick={(e) => close(e)}
              >
                {closeButtonTile}
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BottomModal;
